import React from 'react';
import {
  ReactiveBase,
  DataSearch,
} from '@appbaseio/reactivesearch';
import PropTypes from 'prop-types';

import { Search } from '../../components/ui/icon/Search';
import reactivesearchTheme from '../../reactivesearchTheme';

import './site-search-input.css';

function SiteSearchInput({ url, credentials, app }) {
  return (
    <ReactiveBase
      url={url}
      credentials={credentials}
      app={app}
      enableAppbase
      theme={reactivesearchTheme}
    >
      <>
        <label className="visually-hidden" htmlFor="search-input">search</label>
        <DataSearch
          innerClass={{
            input: 'form-control',
          }}
          componentId="q"
          dataField={['title', 'content']}
          filterLabel="Search term"
          placeholder="What are you looking for?"
          showIcon={false}
          URLParams
          highlight
          customHighlight={() => ({
            pre_tags: ['<mark>'],
            post_tags: ['</mark>'],
            number_of_fragments: 3,
            fields: {
              title: { number_of_fragments: 0 },
              content: {},
            },
          })}
          // searchOperators
          fuzziness="AUTO"
          onValueSelected={(value) => {
            window.location.href = `${window.location.origin}/search/?q="${value}"`;
          }}
        />
        <button type="submit">
          <Search />
        </button>
      </>
    </ReactiveBase>
  );
}

SiteSearchInput.propTypes = {
  url: PropTypes.string.isRequired,
  credentials: PropTypes.string.isRequired,
  app: PropTypes.string.isRequired,
};

export { SiteSearchInput };
